import { createApp } from 'vue'
import { createStore } from 'vuex'
import VueCookies from 'vue-cookies'
import store from './store.js'
import router from './router.js'
import Steps from './components/Steps.vue'
import { tns } from 'tiny-slider/src/tiny-slider'

// The Vue app
const app = createApp({
  components: {
    Steps,
  },
  created() {
    store.dispatch('init')
  }
})
.use(store)
.use(router)
.use(VueCookies)

// 3 days for cookie expiration.
VueCookies.config('3d')

// Include the app instance on the Vuex store.
store.app = app;

// Mount the app.
app.mount('#online-store')

// Product Suggestions
if (document.querySelector('.slideshow .slides')) {
  const slider = tns({
    container: '.slideshow .slides',
    items: 1,
    mode: 'gallery',
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    nav: false,
    lazyload: true,
    responsive: {
      1024: {
        items: 4,
      },
      800: {
        items: 3,
      },
      600: {
        items: 2,
      }
    }
  })
}
